import { request } from "./client";

/**
 * Consolidated Tenant Profile (Business Profile) API Service
 * 
 * Endpoints:
 * 1. GET  /tenants/:tenantId/profile            - Fetch tenant profile & base64 logo (Protected)
 * 2. PUT  /tenants/:tenantId/profile            - Update heading, description, logo_data & logo_mime_type (Protected)
 * 3. POST /tenants/:tenantId/profile/activate   - Activate tenant profile for public view (Protected)
 * 4. POST /tenants/:tenantId/profile/deactivate - Deactivate tenant profile from public view (Protected)
 * 5. GET  /public/tenants/:tenantId/profile     - Fetch active public profile & base64 logo (Public)
 * 6. GET  /tenants/profiles                     - Fetch list of all tenant profiles (Protected)
 * 7. GET  /public/tenants/profiles              - Fetch list of all public tenant profiles (Public)
 */

export const fetchTenantProfile = (tenantId) =>
  request(`/tenants/${tenantId}/profile`, { skipCache: true });

export const updateTenantProfile = (tenantId, payload) =>
  request(`/tenants/${tenantId}/profile`, {
    method: "PUT",
    data: payload,
  });

export const activateTenantProfile = (tenantId) =>
  request(`/tenants/${tenantId}/profile/activate`, {
    method: "POST",
  });

export const deactivateTenantProfile = (tenantId) =>
  request(`/tenants/${tenantId}/profile/deactivate`, {
    method: "POST",
  });

export const fetchPublicTenantProfile = (tenantId) =>
  request(`/public/tenants/${tenantId}/profile`, { skipCache: true });

export const getAllTenantProfiles = () =>
  request("/tenants/profiles", { skipCache: true });

export const getAllPublicTenantProfiles = () =>
  request("/public/tenants/profiles", { skipCache: true });
